export default (arr, rng = Math.random) => arr[Math.floor(rng() * arr.length)]
